export const MAIN_ROUTES = {
  ABOUT_US: "/about-us",
  ACCEPTED_USE_POLICY: "/accepted-use-policy",
  APPLICATION_SERVICES: "/application-services",
  BAREMETAL: "/baremetal",
  BANDWIDTH_BACKUP_OVERAGES: "/bandwidth-backup-policies",
  BOOK_A_CONSULTATION: "/book-a-consultation",
  CATALOG: "/catalog",
  CLOUD_SERVICES: "/cloud-services",
  CODE_OF_CONDUCT: "/code-of-conduct-ba",
  CONTACT_US: "/contact-us",
  DATA_CENTER: "/data-centers",
  DEDICATED_SERVICE_LEVEL_GUARANTEE: "/dedicated-server-level-guarantee",
  CLOUD_SERVICE_LEVEL_AGREEMENT: "/cloud-service-level-agreement",
  CLOUD_TERMS_OF_SERVICE: "/terms-of-service",
  DMCA: "/dmca",
  HOME: "/",
  HOSTING_SERVICES_AGREEMENT: "/hosting-master-services-agreement",
  HOSTING_COLOCATIONS_ERVICES_AGREEMENT: "/hosting-colocation-services-agreement",
  COLOCATION_POLICIES_AND_REGULATIONS: "/hosting-colocation-policies-and-regulations",
  IAAS: "/iaas",
  NETWORK_SERVICES: "/network-services",
  POLICIES: "/policies",
  PRICING: "/pricing",
  SECURITY_SERVICES: "/security-services",
  SERVICE_GUARANTEE: "/service-guarantee",
  SERVICES: "/services",
  LOGOUT: "/logout",
};

export const APPS_ROUTES = {
  HOSTED_GRAFANA: "/hosted-grafana",
  HOSTED_ELASTIC: "/hosted-elastic",
  HOSTED_NOM: "/hosted-nom",
  HOSTED_PBX: "/hosted-pbx",
  HOSTED_NETBOX: "/hosted-netbox",
  HOSTED_RANCHER: "/hosted-rancher",
  INUVIKA_VDI: "/inuvika-vdi",
  GPU_WORKSTATIONS: "/gpu-workstations",
  HOSTED_MAC: "/hosted-mac",
  ISV_DESKTOPS: "/isv-desktops",
};

export const CLOUD_SERVICES_ROUTES = {
  CERTIFICATION_LABS: "/certification-labs",
  CLOUD_GPU: "/cloud-gpu",
  EMULATE_SIMULATE_REAL: "/emulate-simulate-real",
  ENCRYPTED_STORAGE_CLUSTERS: "/encrypted-storage-clusters",
  LAB_AS_A_SERVICE: "/lab-as-a-service",
  LOAD_BALANCERS: "/load-balancers",
  IPV4V6: "/ipv4-v6",
  KUBERNETES: "/kubernetes",
  MICROSOFT_365: "/microsoft-365",
  MANAGED_UNMANAGED_CO_MANAGED: "/managed-unmanaged-co-managed",
  NETWORK_AUTOMATION: "/network-automation",
  NETWORK_DIGITAL_TWINS: "/network-digital-twins",
  OEM_CONVERGED_ARCHITECTURE: "/oem-converged-architecture",
  OPEN_STACK_CLOUD: "/open-stack-cloud",
  PAAS: "/paas",
  PERFORMANCE_LABS: "/performance-labs",
  PHYSICAL_LABS: "/physical-labs",
  POC_AS_A_SERVICE: "/poc-as-a-service",
  PRIVATE_K8_CLUSTERS: "/private-k8-clusters",
  PRIVATE_VDI: "/vdi-on-private-cloud",
  SHARED_COMPUTE: "/shared-compute",
  VDI: "/vdi",
  VIRTUOZZO_PAAS: "/virtuozzo-paas",
  VMWARE_CLOUD: "/vmware-cloud",
  ZADARA_CLOUD: "/zadara-cloud",
  MIGRATE_TO_MOST: "/migrate-to-most",
  BAREMETAL: "/bare-metal",
  DEDICATED_SERVER: "/dedicated-servers",
  GPU_HOSTING: "/gpu-hosting",
  BLOCK_AND_S3_STORAGE: "/block-and-s3-storage",
  DISASTER_RECOVERY: "/disaster-recovery",
};

export const SECURITY_SERVICES_ROUTES = {
  CLOUD_SECURITY: "/cloud-security",
  COMPLIANCE_MANAGEMENT: "/compliance-management-sec-ops",
  EDR_MDR_XDR: "/edr-mdr-xdr",
  RANSOMWARE_DDOS_PROTECTION: "/ransomware-ddos-protection",
  VULNERABILITY_PATCH_MANAGEMENT: "/vulnerability-patch-management",
  ZTNA_VPN_EDGE_FIREWALL_SASE: "/ztna-vpn-edge-firewall-sase",
  SECURITY_TESTING: "/security-testing",
};

export const NETWORK_SERVICES_ROUTES = {
  CLOUD_UNIFIED_COMMUNICATION: "/unified-communication",
  COLOCATION: "/managed-colocation",
  CLOUD_MIGRATION: "/cloud-migrations",
  DESIGN_AND_DEPLOYMENT: "/design-and-deployment",
  INTERNET_AND_DCI: "/internet-and-dci",
  NETWORK_OBSERVABILITY_AND_NMS: "/network-observability-and-nms",
  NOC_SOC_HELPDESK: "/noc-soc-helpdesk",
  SDN_SD_WAN: "/sdn-sd-wan",
  VMWARE_MIGRATION: "/vmware-migrate",
  MIGRATE_TO_ZADARA: "/migrate-to-zadara",
  WIRED_AND_WIRELESS_NETWORKS: "/wired-and-wireless-infra",
};

export const CLOUD_MIGRATIONS_ROUTES = {
  VMWARE_MIGRATION: "/vmware-migrate",
  MIGRATE_TO_ZADARA: "/migrate-to-zadara",
  GCP_TO_MOST: "/gcp-to-most",
  EC2_TO_ZADARA: "/ec2-to-zadara",
  K8_MIGRATE: "/k8-to-paas",
};
